import React, { useEffect, useState } from "react";
import TextMedium from "../TextComponent/TextMedium";
import TextSmall from "../TextComponent/TextSmall";
import { ReactComponent as GoalIcon } from "../../../build/images/iconmeta.svg";
import { ReactComponent as LoadingPerfomance } from "../../../build/images/loadingmanagerperfomance.svg";
import { ResponsiveLine } from '@nivo/line';
import { useSelector } from "react-redux";
import { ReactComponent as EmptyState } from "../../../build/images/emptystatemanagerhorizontal.svg";
import { ReactComponent as EditMetaIcon } from "../../../build/images/editmeta.svg";
import { Bar, Line, XAxis, YAxis, ResponsiveContainer, CartesianGrid, Tooltip, Legend, Area, ComposedChart } from 'recharts';
import _ from 'lodash';
import Moment from 'moment';
import MicroModal from "micromodal";
import MetaValueModal from "../../modals/MetaValueModal";

let dataT = [
  {
    "name": "5h15min",
    "uv": 4000,
    "pv": 2400,
    "amt": 2400
  },
  {
    "name": "5h30min",
    "uv": 3000,
    "pv": 1398,
    "amt": 1398
  },
  {
    "name": "5h45min",
    "uv": 2000,
    "pv": 3200,
    "amt": 3200
  },
  {
    "name": "6h00min",
    "uv": 2780,
    "pv": 2000,
    "amt": 2000
  },
  {
    "name": "6h15min",
    "uv": 1890,
    "pv": 2181,
    "amt": 2181
  },
  {
    "name": "6h30min",
    "uv": 2390,
    "pv": 2500,
    "amt": 2500
  },
  {
    "name": "6h45min",
    "uv": 3490,
    "pv": 2100,
    "amt": 2100
  },
  {
    "name": "7h00min",
    "uv": 3000,
    "pv": 2210,
    "amt": 2210
  },
]
let data1 = [];
let data2 = [];
let data1And2 = [];
let dateNow = Moment().format('DD/MM/YYYY');
let dateCompare = Moment().subtract(7, 'days').format('DD/MM/YYYY');
let checkMeta = 0;

function refactoredDataJson (jsonData,FiltersManager,percentualNs) {
      let compare = jsonData;


      compare = compare.filter(filt => FiltersManager.filter_manager_service.includes(filt.idgrupo))
      compare = compare.filter(filt => FiltersManager.filter_manager_channel.includes(filt.idmidia))
      
      
      let qtdRecebidas = 0;
      let qtdAtendidas = 0;
      let qtdForaSla = 0;
      let jsonRefactored = [];
      let hour = "00"
      let percentual = percentualNs;

      compare.push({
        hora: hour+'h',
        qtde_atendidas: qtdAtendidas,
        qtde_recebidas: qtdRecebidas,
        qtde_atendida_fora_sla: qtdForaSla,
        percentual_ns: percentualNs,
        valorNSFinal: null
      })

      for(let i=0; i<compare.length; i++){           

        if(hour !== compare[i].hora){
          let temp = jsonRefactored.filter(json => json.hora === hour+'h');
          if(temp.length === 0 && hour !== "00"){
            let qtdCurtas = 0;
            let valorNSFinal = qtdAtendidas > 0 ?  (((((parseInt(qtdAtendidas)-parseInt(qtdForaSla)) /  ((parseInt(qtdRecebidas)-parseInt(qtdCurtas)))) /percentualNs)*100)) : 0

            if (valorNSFinal>100)
                valorNSFinal=100

            jsonRefactored.push({
              hora: hour+'h',
              qtde_atendidas: qtdAtendidas,
              qtde_recebidas: qtdRecebidas,
              qtde_atendida_fora_sla: qtdForaSla,
              percentual_ns: percentualNs,
              valorNSFinal: valorNSFinal
            })
          }
          qtdAtendidas = 0;
          qtdRecebidas = 0;
          qtdForaSla = 0;
          hour = compare[i].hora;
        }

        for(let j=0; j<compare.length; j++){           
          if(hour === compare[j].hora){
            qtdAtendidas = qtdAtendidas+compare[j].qtde_atendidas;
            qtdRecebidas = qtdRecebidas+compare[j].qtde_recebidas;
            qtdForaSla = qtdForaSla+compare[j].qtde_atendida_fora_sla;
            percentualNs = percentual !== 0 ? parseFloat((percentual/100).toFixed(1)):compare[j].percentual_ns;
            if(percentual === 0 && checkMeta === 0){
              localStorage.setItem('meta_manager_perfomance', 100*compare[j].percentual_ns)
              checkMeta = 1;
            }
          }
        }        
      }

      jsonRefactored = _.orderBy(jsonRefactored, 'hora','asc');

      return jsonRefactored
}

export default function CardPerfomance({title}) {
  let localStorageMeta = localStorage.getItem('meta_manager_perfomance');
  const LoginCompleteReducer = useSelector(state => state.ipcurrent);
  const PerfomanceData = useSelector(state => state.datamanagerperfomance);
  const [dataPerfomance, setDataPerfomance] = useState([]);
  const [dataPerfomanceCompare, setDataPerfomanceCompare] = useState([]);
  const FiltersManager = useSelector(state => state.filtersmanager);
  const [value, setValue] = useState(localStorageMeta ? parseInt(localStorageMeta):0);
  const [metaValue, setMetaValue] = useState(localStorageMeta ? parseInt(localStorageMeta):0);
  const line1Color = "gray";
  const line2Color = "blue";
  let countPerfomance = 1;

  const getColoredAxis = color => {
    return {
      axis: {
        ticks: {
          line: {
            stroke: color
          },
          text: { fill: color }
        },
        legend: {
          text: {
            fill: color
          }
        }
      }
    };
  };

  const handleMetaValue = () => {
    setMetaValue(value);
    MicroModal.close('modal__edit_meta_value')
  }

  const OpenModalMeta = () => {
    MicroModal.show("modal__edit_meta_value");
  }

  const concatArrayCompare = (perfomanceCurrent,perfomanceCompare) => {
    let test = false;
    let aux = [];
    for(let i=0; i<perfomanceCurrent.length; i++){ 
      for(let j=0; j<perfomanceCompare.length; j++){ 
        if(perfomanceCompare[j].hora === perfomanceCurrent[i].hora){
          test = true;
        }
      }
      if(test === false){
        aux.push({
          hora: perfomanceCurrent[i].hora,
          valorNSFinal: perfomanceCurrent[i].valorNSFinal
        })
      }
      test = false;
    }
    return aux;
  }

  useEffect(() => {
    if(PerfomanceData.length !== 0 && FiltersManager.is_active){
      if(PerfomanceData.perfomance && PerfomanceData.perfomance_compare){
        data1 = [];
        data2 = [];
        data1And2 = [];

        let PerfomanceDataCurrent = JSON.parse(PerfomanceData.perfomance);
        let PerfomanceDataCompare = JSON.parse(PerfomanceData.perfomance_compare);


        let jsonPerfomance = refactoredDataJson(PerfomanceDataCurrent,FiltersManager,value)
        let jsonPerfomanceCompare = refactoredDataJson(PerfomanceDataCompare,FiltersManager,value)


        if(checkMeta === 1){
          setMetaValue(localStorage.getItem('meta_manager_perfomance'))
          setValue(localStorage.getItem('meta_manager_perfomance'))
          checkMeta = 2
        }

        let unifyArray = concatArrayCompare(jsonPerfomance,jsonPerfomanceCompare);

        unifyArray.map(uni => {
          uni.valorNSFinal = null;
        })

        unifyArray.map(uni => {
          jsonPerfomanceCompare.push(uni);
        })

        let unifyArray2 = concatArrayCompare(jsonPerfomanceCompare,jsonPerfomance);

        unifyArray2.map(uni => {
          uni.valorNSFinal = null;
        })

        unifyArray2.map(uni => {
          jsonPerfomance.push(uni);
        })

        jsonPerfomanceCompare = _.orderBy(jsonPerfomanceCompare, 'hora','asc');
        jsonPerfomance = _.orderBy(jsonPerfomance, 'hora','asc');


        let tempPerfomance = [];
        let tempPerfomanceCompare = [];
        jsonPerfomance.map(json => {
          tempPerfomance.push({
            "x": json.hora,
            "y": json.valorNSFinal !== null ? Math.round(json.valorNSFinal):json.valorNSFinal
          })
        })
        data1.push(
          {
            "id": dateNow,
            "color": "hsl(128, 70%, 50%)",
            "data": tempPerfomance
          }
        )
        jsonPerfomanceCompare.map(json => {
          tempPerfomanceCompare.push({
            "x": json.hora,
            "y": json.valorNSFinal !== null ? Math.round(json.valorNSFinal):json.valorNSFinal
          })
        })
        data2.push(
          {
            "id": dateCompare,
            "color": "hsl(206, 70%, 50%)",
            "data": tempPerfomanceCompare
          }
        )

        let mountChart = mountDataChart(tempPerfomance,tempPerfomanceCompare)

        dataT = mountChart

        data1And2 = data2.concat(data1);

        setDataPerfomance(jsonPerfomance)
        setDataPerfomanceCompare(jsonPerfomanceCompare)
      }
    }
  }, [PerfomanceData,FiltersManager,metaValue])

  function mountDataChart (oneArray,twoArray) {
    let mount = [];
    for(let i=0; i<oneArray.length; i++){ 
      mount.push({
        "name": oneArray[i].x,
        "Hoje": oneArray[i].y,
        [dateCompare]: twoArray[i].y,
        "amt": oneArray[i].y,
      }) 
    }
    return mount
  }

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div className="custom-tooltip">
          <p className="label">{payload[0].payload.name}</p>
          {Object.entries(payload[0].payload).map((key, value) => {
                if(value === 1 || value === 2){
                  return (
                    <div className="manager-component__card-perfomance__title-itens">
                          {key[1] !== null && <><div className={value === 1 ? "manager-component__card-perfomance__title-itens__circle blue":"manager-component__card-perfomance__title-itens__circle yellow"}></div>
                          <TextSmall text={`${key[0]}: ${key[1]}%`} color="gray" /></>}
                    </div>
                  );
                }
            })
          }
        </div>
      );
    }
  
    return null;
  };

  return (
    <div className="manager-component__card-perfomance">
        <div className="manager-component__card-perfomance__title">
           <TextMedium text={title} color="gray" />
           <div className="manager-component__card-perfomance__title-itens">
                <div className="manager-component__card-perfomance__title-itens__circle blue"></div>
                <TextSmall text={dateNow} color="gray" />
           </div>
           <div className="manager-component__card-perfomance__title-itens">
                <div className="manager-component__card-perfomance__title-itens__circle yellow"></div>
                <TextSmall text={dateCompare} color="gray" />
           </div>
           <div className="manager-component__card-perfomance__title-itens" onClick={() => OpenModalMeta()} style={{cursor: 'pointer'}}>
                <div><GoalIcon /></div>
                <TextSmall text={`Meta de ${metaValue}%`} color="gray" />
                <div >
                  <EditMetaIcon />
                </div>
           </div>
        </div>
        <div className="manager-component__card-perfomance__box-chart">
        {LoginCompleteReducer.isLoginComplete ?
          countPerfomance !== 0 ?
            <div className="wrapper__manager-perfomance">
              <div className="graphContainer">
                {data1And2.length !== 0 &&
                // <ResponsiveLine
                //     data={[
                //         {
                //             id: data1[0].id,
                //             data: data1[0].data.map((y, i) => ({x: `${y.x}`, y: y.y})),
                //             "color": "hsl(128, 70%, 50%)",
                //         },
                //         {
                //             id:  data2[0].id,
                //             data: data2[0].data.map((y, i) => ({x: `${y.x}`, y: y.y})),
                //             "color": "hsl(206, 70%, 50%)",
                //         },
                //     ]}
                //     // data={data1And2}
                //     yScale={{
                //         type: 'linear',
                //         stacked: false,
                //     }}
                //     colors={(props) => {return props.color === 'hsl(206, 70%, 50%)' ? 'blue':'red'}}
                //     margin={{ top: 10, right: 50, bottom: 30, left: 50 }}
                //     curve="linear"
                //     axisLeft={{
                //       // legend: "Points Scored",
                //       legendPosition: "middle",
                //       legendOffset: -40
                //     }}
                //     theme={getColoredAxis(line1Color)}
                //     enablePoints={true}
                //     enableGridX={false}
                //     pointSize={8}
                //     pointColor="#f7f7f7"
                //     pointBorderWidth={1}
                //     pointLabelYOffset={-13}
                //     areaBaselineValue={30}
                //     areaOpacity={0}
                //     pointBorderColor={(props) => {return props.serieColor}}
                //     enableSlices="x"
                //     sliceTooltip={({ slice }) => {
                //       return (
                //           <div
                //               style={{
                //                 background: 'white',
                //                 padding: '9px 12px',
                //                 border: '1px solid #ccc',
                //               }}
                //           >
                //             <div>x: {slice.points[0].data.x}</div>
                //             {slice.points.map(point => (
                //                 <div
                //                     key={point.id}
                //                     style={{
                //                       color: point.serieColor === "rgba(255, 255, 255, 0)" ? line1Color : point.serieColor,
                //                       padding: '3px 0',
                //                     }}
                //                 >
                //                   <strong>{point.serieId}</strong> [{point.data.yFormatted}]
                //                 </div>
                //             ))}
                //           </div>
                //       )
                //     }}
                // />
                <ResponsiveContainer width="100%" height="100%">
                  <ComposedChart data={dataT} >
                    <XAxis dataKey="name" />
                    <YAxis />
                    <Tooltip 
                      content={<CustomTooltip />} 
                    />
                    <CartesianGrid stroke="#f5f5f5" />
                    <Bar barSize={15} dataKey={dateCompare} fill="#C0CA33" />
                    <Area type="linear" dataKey="Hoje" fill="#b4bde8" stroke="#8884d8" />
                    <Line type="linear" dataKey="amt" stroke="#455CC7" strokeWidth={2} />
                  </ComposedChart>
                </ResponsiveContainer>
              }
              </div>
            </div>
            : 
            <EmptyState />

          : <LoadingPerfomance />
        }
        </div>
        <MetaValueModal handleMetaValue={handleMetaValue} setValue={setValue} value={value} setMetaValue={setMetaValue} />
    </div>
  );
}